/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MallEdit_mall$ref = any;
export type MallEditQueryVariables = {||};
export type MallEditQueryResponse = {|
  +mall: ?{|
    +$fragmentRefs: MallEdit_mall$ref
  |}
|};
export type MallEditQuery = {|
  variables: MallEditQueryVariables,
  response: MallEditQueryResponse,
|};
*/


/*
query MallEditQuery {
  mall {
    ...MallEdit_mall
    id
  }
}

fragment MallEdit_mall on Mall {
  name
  phoneNumber
  email
  pdfMapUrl
  address
  smallMapUrl
  largeMapUrl
  mondayOpening
  mondayClosing
  tuesdayOpening
  tuesdayClosing
  wednesdayOpening
  wednesdayClosing
  thursdayOpening
  thursdayClosing
  fridayOpening
  fridayClosing
  saturdayOpening
  saturdayClosing
  sundayOpening
  sundayClosing
}
*/

const node/*: ConcreteRequest*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MallEditQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Mall",
        "kind": "LinkedField",
        "name": "mall",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MallEdit_mall"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MallEditQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Mall",
        "kind": "LinkedField",
        "name": "mall",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phoneNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pdfMapUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "address",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "smallMapUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "largeMapUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mondayOpening",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mondayClosing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tuesdayOpening",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tuesdayClosing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wednesdayOpening",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wednesdayClosing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thursdayOpening",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thursdayClosing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fridayOpening",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fridayClosing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "saturdayOpening",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "saturdayClosing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sundayOpening",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sundayClosing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "MallEditQuery",
    "operationKind": "query",
    "text": "query MallEditQuery {\n  mall {\n    ...MallEdit_mall\n    id\n  }\n}\n\nfragment MallEdit_mall on Mall {\n  name\n  phoneNumber\n  email\n  pdfMapUrl\n  address\n  smallMapUrl\n  largeMapUrl\n  mondayOpening\n  mondayClosing\n  tuesdayOpening\n  tuesdayClosing\n  wednesdayOpening\n  wednesdayClosing\n  thursdayOpening\n  thursdayClosing\n  fridayOpening\n  fridayClosing\n  saturdayOpening\n  saturdayClosing\n  sundayOpening\n  sundayClosing\n}\n"
  }
};
// prettier-ignore
(node/*: any*/).hash = '25b6d27ef1253d50deea8e307f857ed2';

module.exports = node;
